export default __webpack_public_path__ + "static/media/e3aefdb39408e27e4c12f7882e4c9eb7.svg";